import { identity } from "../../../lib/utils/Identity.js";
import { VideoInfoRawData } from "../../../model/video/VideoInfo.js";
import { AdUnit } from "../AdUnit.js";
import { AdParamsEnricher, PrebidModule } from "./PrebidModule.js";

export class NullPrebidModule implements PrebidModule {


    constructor(){}
    

    load(): Promise<void> {
        return Promise.resolve();
    }
    bidAndGetEnricher(adUnit: AdUnit, info: VideoInfoRawData): Promise<AdParamsEnricher> {
        return Promise.resolve(identity);
    }

}